import { cn } from '@skupreme/shared/ui';
import { getFlagSrc } from '../../lib/flags';

export type LocaleCellProps = {
  countryCode?: string;
  region?: string;
  className?: string;
};

export function LocaleCell({
  countryCode,
  region,
  className,
}: LocaleCellProps) {
  const flag = getFlagSrc(countryCode);

  if (!flag && !region) {
    return <span className="sk:text-fg-tertiary">—</span>;
  }

  return (
    <span
      className={cn(
        'sk:inline-flex sk:max-w-full sk:items-center sk:gap-1.5',
        className,
      )}
    >
      {flag ? (
        <img
          src={flag}
          alt={countryCode}
          className="sk:h-3 sk:w-4 sk:shrink-0 sk:rounded-xs sk:object-cover"
        />
      ) : null}
      <span className="sk:min-w-0 sk:truncate sk:font-medium sk:uppercase">
        {region || countryCode}
      </span>
    </span>
  );
}
